<template>
  <SearchForm />
</template>

<script>
import SearchForm from './SearchForm';

export default {
  name: 'Search',
  components: {
    SearchForm
  },
  data() {
    return {
    }
  }
};
</script>